import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Language {
  value: string;
  label: string;
  flag: string;
}

interface LanguageState {
  languageList: Language[];
  setLanguageList: (languages: Language[]) => void;
}

const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      languageList: [],
      setLanguageList: (languages: Language[]) => {
        const sorted = [...languages].sort((a, b) => {
          if (a.label === 'English') return -1;
          if (b.label === 'English') return 1;
          return a.label.localeCompare(b.label);
        });

        set({ languageList: sorted });
      }
    }),
    {
      name: 'language-list-storage'
    }
  )
);

export default useLanguageStore;
